export default {
  title: {
    'zh-cn': '套餐管理',
    'zh-tw': '套餐管理',
    'en': 'Package Management'
  },
  // 卡片标题
  currentPlan: {
    'zh-cn': '当前套餐',
    'zh-tw': '當前套餐',
    'en': 'Current Plan'
  },
  videoPlan: {
    'zh-cn': '视频套餐',
    'zh-tw': '視頻套餐',
    'en': 'Video Plan'
  },
  srPlan: {
    'zh-cn': '内地车牌识别接口套餐',
    'zh-tw': '內地車牌識別接口套餐',
    'en': 'Mainland License Plate Recognition API Plan'
  },
  // 提示文本
  orderTip: {
    'zh-cn': '暂未开放线上订购，如您有订购需求，请先联系您的商务经理',
    'zh-tw': '暫未開放線上訂購，如您有訂購需求，請先聯繫您的商務經理',
    'en': 'Online ordering is not yet available. If you need to order, please contact your business manager first'
  }
}

